import React, { useContext } from 'react'
import NotificationContent from 'Components/Notifications/NotificationContent'
import SearchContentNotifications from 'Components/Header/SearchContentNotifications';
import { Context } from 'Context/Context';
import Header from 'Components/Header/Header';

function ProfNotifications({attorney, setLoadNotification}) {
  const {userDetails} = useContext(Context);
  const userInfo = attorney ? attorney.userId : userDetails;
  return  <>
        <Header showDashboard={true} />
        <div className='flex col-span-6 w-full flex-col font-plexsans' style={{ background: '#f7f4ed', minHeight: 'calc(100vh - 64px)' }}>
          <div className='w-full max-w-[960px] mx-auto px-5 py-8 lg:px-10 lg:py-12'>
            <NotificationContent
              title="Notifications"
              attorney={attorney}
              setLoadNotification={setLoadNotification}
              headerExtra={<SearchContentNotifications userId={userInfo?._id} attorney={attorney}/>}
            />
          </div>
        </div>
  </>
}

export default ProfNotifications
